import {FileUploadRes} from '@yasc/yasc-material-components';
import {Type} from 'class-transformer';
import {UserDetailsMinRes} from '../cp';
import {DeviceInfoRes} from './device-info';

export class LicenseAssignmentResponse {
    public readonly guid!: string;
    public readonly createdAt!: Date;
    @Type(() => UserDetailsMinRes)
    public readonly createdBy: UserDetailsMinRes = new UserDetailsMinRes();
    public readonly updatedAt!: Date;
    @Type(() => UserDetailsMinRes)
    public readonly updatedBy: UserDetailsMinRes = new UserDetailsMinRes();

    public name?: string;
    public title?: string;
    public description?: string;

    @Type(() => UserDetailsMinRes)
    public assignedUserList: UserDetailsMinRes[] = [];

    public deviceCount?: number;
    @Type(() => DeviceInfoRes)
    public devices: DeviceInfoRes[] = []

    supportingDocuments: string[] | FileUploadRes[] = [];

    public clone(response: LicenseAssignmentResponse): LicenseAssignmentResponse {
        let responseClone = new LicenseAssignmentResponse();
        responseClone.name = response.name;
        responseClone.title = response.title;
        responseClone.description = response.description;
        responseClone.deviceCount = response.deviceCount;
        return responseClone;
    }
}

export class LicenseAssignmentRequest {
    public guid?: string;
    public createdAt?: Date;
    public createdBy?: string;
    public updatedAt?: Date;
    public updatedBy?: string;
    public name?: string;
    public title?: string;
    public description?: string;
    public deviceCount?: number;
    public deviceIds?: number[] = []

    supportingDocuments: string[] | FileUploadRes[] = [];

    public fromResponse(response: LicenseAssignmentResponse): LicenseAssignmentRequest {
        let request = new LicenseAssignmentRequest();
        request.name = response.name;
        request.title = response.title;
        request.description = response.description;
        request.deviceCount = response.deviceCount;
        return request;
    }
}

export class LicenseAssignmentCsvImportRequest {
    mappingId!: number;
    data!: any[];

    constructor(mappingId: number, data: any[]) {
        this.mappingId = mappingId;
        this.data = data;
    }
}